import React from "react";
import styles from "./SplashScreen.module.scss";

const SplashScreen = () => {
  return (
    <div className={styles.pulse}>
      <h1 className={styles.pulse}>Aware Technology</h1>
    </div>
  );
};

export default SplashScreen;
